module.exports = __webpack_public_path__ + "static/media/dicon-3.64debba5.svg";